import { Navigate, createFileRoute } from "@tanstack/react-router";
import { useAuth } from "@/lib/keycloak/use-auth";
import { useOnboarding } from "@/features/onboarding/hooks/use-onboarding";
import { getStepMeta } from "@/features/onboarding/constants/steps";

export const Route = createFileRoute("/onboarding/")({
	component: OnboardingIndexRedirect,
});

/**
 * Redirects to the correct onboarding step based on the current state.
 * Uses the onboarding context (provided by the parent layout) which already
 * handles step resolution from server state + auth state + local storage.
 *
 * Waits for onboarding status to load before redirecting so the resolved
 * step accounts for server state (personal data, phone, legal, etc.).
 */
function OnboardingIndexRedirect() {
	const { authenticated } = useAuth();
	const { currentStepId, onboardingStatus } = useOnboarding();

	// Wait for server state before redirecting so we resolve the correct step
	if (authenticated && !onboardingStatus) {
		return null;
	}

	const meta = getStepMeta(currentStepId);

	return <Navigate to={meta?.path ?? "/onboarding/start"} replace />;
}
